import { ReactElement } from "react";
import { Dashboard } from "./Dashboard/Dashboard";

export const HomePage = (): ReactElement => <Dashboard />;

export default HomePage;
